import { StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { initTheme } from '@aimmo/ui';
import { buildRouter } from './router.js';
import { queryClient } from './lib/query-client.js';
import { registerServiceWorker } from './lib/pwa.js';
import { startStats } from './lib/stats-boot.js';
import './app.css';

// Before first paint, so a dark-mode user never sees a light flash.
initTheme();

// No-op in dev: the plugin only emits a worker for a build.
registerServiceWorker();

const router = buildRouter(queryClient);

// Usage statistics (M17): no-op unless this build carries the tracker.
startStats(router);

const container = document.getElementById('root');
if (!container) throw new Error('#root not found');

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <Suspense fallback={null}>
        <RouterProvider router={router} />
      </Suspense>
    </QueryClientProvider>
  </StrictMode>,
);
